<template>
    <div class="p-4 bg_green rounded position-relative">
        <div class="position-absolute w-100 h-100 top-0 end-0 start-0 bottom-0 d-flex justify-content-center align-items-center bg-white bg-opacity-50"
            style="z-index: 2;" v-if="loading">
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-if="step < 5">
            <div class='modal-header mb-3 d-flex align-items-center justify-content-between'>
                <h4 class='modal-title'>Верификация</h4>
                <div class="d-none d-md-flex align-items-center">
                    <span :class="step > 0 ? 'operation_steps_active' : 'operation_steps'">1</span>
                    <img width="49" height="2" src="/static/img/buy/line.svg" />
                    <span :class="step > 1 ? 'operation_steps_active' : 'operation_steps'">2</span>
                    <img width="49" height="2" src="/static/img/buy/line.svg" />
                    <span :class="step > 2 ? 'operation_steps_active' : 'operation_steps'">3</span>
                </div>
                <button class="btn-close btn-close-white shadow-none" type="button" @click="close"></button>
            </div>
            <div class="mb-3 d-flex d-md-none align-items-center">
                <span :class="step > 0 ? 'operation_steps_active' : 'operation_steps'">1</span>
                <img width="49" height="2" src="/static/img/buy/line.svg" />
                <span :class="step > 1 ? 'operation_steps_active' : 'operation_steps'">2</span>
                <img width="49" height="2" src="/static/img/buy/line.svg" />
                <span :class="step > 2 ? 'operation_steps_active' : 'operation_steps'">3</span>
            </div>
            <div v-if="step < 3" class="modal-body register_block">
                <p style="font-size: 13px;" class="px-3 py-2 bg_lightgreen rounded text-black">
                    Все данные, отправленные в данном окне, будут зашифрованы и надежно хранится на наших распределенных
                    серверах, данные никогда не будут переданы третьим лицам
                </p>
                <span>Введите ваше ФИО</span>
                <input id="ver_fio" @change="checkALlFields" class='o-input text-center' v-model='fio' type='text'
                    placeholder='ФИО' />
                <div class="mt-4">
                    <span>Ваш email</span>
                    <div class="d-flex align-items-center flex-wrap">
                        <span class="fs-5 me-3 overflow-hidden text-truncate" v-if="mail">{{ mail }}</span>
                        <span class="fs-5 me-3 overflow-hidden text-truncate" v-else>{{ user ? user.email : '' }}</span>
                        <span class='text-green text-decoration-none cursor-pointer' type="button"
                            data-bs-toggle="modal" data-bs-target="#exampleModal">Изменить</span>
                    </div>
                </div>
                <div class="mt-4">
                    <span>Ваш номер</span>
                    <div class="d-flex align-items-center flex-wrap">
                        <span class='fs-5 me-3'  v-if="phone">{{ phone  }}</span>
                        <span class='fs-5 me-3' v-else>{{ user?.phone_number  }}</span>
                        <span class='text-green text-decoration-none cursor-pointer' type="button"
                            data-bs-toggle="modal" data-bs-target="#exampleModal2">Изменить</span>
                    </div>
                </div>

                <!-- <div class="error-block-text" v-if="step == 2 && isCode !== true">
                    <p>На этот номер придет звонок, введите последние 4 цифры входящего номера</p>
                </div> -->

                <!-- <div v-if="step == 2 && isCode == false"
                    class="d-flex justify-content-between align-items-center w-100">
                    <input id="ver_codeForPhone text-center" style='width: 60%;' v-model='codeForPhone'
                        class='o-input mb-2' type='text' placeholder='код из номера' />
                    <div class="d-flex flex-column">
                        <span @click="checkCode('phone')" class='link mt-3'>Подтвердить</span>
                        <span v-if="countDown == 30" @click='countDownTimer' class="link" style="font-size:12px;">Новый
                            звонок</span>
                        <span v-else class="custom-file__text" style="font-size: 12px; color: #69E278;">Будет доступно
                            через:<br> {{ countDown }} секунд</span>
                    </div>
                </div> -->
                <div class="error-block-text" v-if="errorText.phone">
                    <p>{{ errorText.phone }}</p>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <button :disabled="!fio" class='button mt-5 w-100 mw-100' @click='next'>Далее</button>
                    </div>
                </div>

            </div>
            <div v-else-if="step === 3" class="modal-body mt-5">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <p>Прикрепите фотографии подтверждающие вашу личность</p>
                    </div>
                </div>

                <div class="row gy-3">
                    <div class="col-6 col-md-3">
                        <input @change="checkALlFields" id='js-file-2' style='cursor: pointer; display: none;'
                            @input='addPass1' slot='' class='image-file js-file custom-file__input' type='file'
                            name='uploadFile' />
                        <label class='w-100 light_link_300 text-white lh-1 overflow-hidden' for='js-file-2'>
                            <div class="bg_lightgreen fs-3 d-flex justify-content-center align-items-center rounded mb-2 overflow-hidden"
                                style="aspect-ratio: 1/1; height: 100px;">
                                <span v-if="!pass1">+</span>
                                <img v-else :src="imageUrl1" alt="Загруженное фото"
                                    class="w-100 h-100 object-fit-cover" />

                            </div>
                            <span class='text-wrap text-break align-items-center'>
                                <span class="w-50 text-truncate" v-if="pass1">{{ pass1.name }}</span>
                                <span v-else>Фото паспорта (лицевая сторона)</span>
                            </span>
                        </label>
                    </div>

                    <div class="col-6 col-md-3">
                        <input @change="checkALlFields" id='js-file-3' style='cursor: pointer;' @input='addPass2'
                            slot='' class='image-file js-file custom-file__input' type='file' name='uploadFile' />
                        <label class='w-100 light_link_300 text-white lh-1 overflow-hidden' for='js-file-3'>
                            <div class="bg_lightgreen fs-3 d-flex justify-content-center align-items-center rounded mb-2 overflow-hidden"
                                style="aspect-ratio: 1/1; height: 100px;">
                                <span v-if="!pass2">+</span>
                                <img v-else :src="imageUrl2" alt="Загруженное фото"
                                    class="w-100 h-100 object-fit-cover" />

                            </div>
                            <span class='text-wrap text-break align-items-center'>
                                <span class="w-50 text-truncate" v-if="pass2">{{ pass2.name }}</span>
                                <span v-else>Фото паспорта(прописка)</span>
                            </span>
                        </label>
                    </div>

                    <div class="col-6 col-md-3">
                        <input @change="checkALlFields" id='js-file-4' style='cursor: pointer; display: none;'
                            @input='addPass3' slot='' class='image-file js-file custom-file__input' type='file'
                            name='uploadFile' />
                        <label class='w-100 mb-4 light_link_300 text-white lh-1 overflow-hidden' for='js-file-4'>
                            <div class="bg_lightgreen fs-3 d-flex justify-content-center align-items-center rounded mb-2 overflow-hidden"
                                style="aspect-ratio: 1/1; height: 100px;">
                                <span v-if="!pass3">+</span>
                                <img v-else :src="imageUrl3" alt="Загруженное фото"
                                    class="w-100 h-100 object-fit-cover" />

                            </div>
                            <span class='text-wrap text-break align-items-center'>
                                <span class="w-50 text-truncate" v-if="pass3">{{ pass3.name }}</span>
                                <span v-else>Селфи с паспортом (лицевая сторона)</span>
                            </span>
                        </label>
                    </div>
                </div>

                <div style="display: flex;">
                    <span style="font-size: 16px; color: #3EA075;">*</span>
                    <span
                        style="color: #3EA075; margin-bottom:0;font-size: 12px; line-height: 19px; font-weight: 400; font-family: Montserrat;">При
                        загрузке документов используйте файлы форматов: png, jpeg, pdf.
                        Максимальный размер файла - 5 мб.</span>
                </div>
                <!-- <button style='width: 45%' class='button button--full-width' @click='prev'>Назад</button> -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <button :disabled='ALlFields == true ? false : true' class='button mt-4 w-100 mw-100'
                            @click='send'>Подтвердить</button>
                    </div>
                </div>
            </div>

            <div v-else class='modal-body pe-4'>
                <p style="font-size: 13px;">Данные успешно отправлены</p>
                <h3 class="fs-5">Срок верификации от 30 до 60 минут</h3>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <button class='button w-100 mw-100 mt-5' @click='close'>Окей</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content bg_green">
                    <div class='modal-header border-0 d-flex align-items-center justify-content-between'>
                        <h5 class='modal-title'>Изменить Email</h5>
                        <div class="d-flex align-items-center justify-content-end">
                            <span :class="stepMail > 0 ? 'operation_steps_active' : 'operation_steps'">1</span>
                            <img width="49" height="2" src="/static/img/buy/line.svg" />
                            <span :class="stepMail > 1 ? 'operation_steps_active' : 'operation_steps'">2</span>
                        </div>
                    </div>
                    <div class='modal-body register_block'>
                        <span v-if="stepMail !== 2">Введите новый Email</span>
                        <div class="mb-3" v-if="stepMail !== 2">
                            <input id="ver_checkMail" type="email" class="form-control shadow-none" placeholder="name@example.com" v-model='newMail'>
                          </div>
                        <div class="error-block-text" v-if="errorText.mail">
                            <p>{{ errorText.mail }}</p>
                        </div>
                        <p class="my-4" v-if="stepMail !== 2">Отправим код <br> на этот Email</p>
                        <div class="mb-3" v-if="stepMail == 2">
                            <input id="ver_codeForMail" type="email" class="form-control shadow-none" v-model='codeForMail' placeholder='Код из Email'>
                          </div>
                        <span v-if="stepMail == 2">Код отправлен на {{newMail}} <span class="text-green cursor-pointer" @click="stepMail = 1" >Изменить</span></span>
                        <div class="row mt-5 gy-2">
                            <div class="col-12 col-md-6">
                                <button type="button" class="btn bg_lightgreen btn-lg text-white w-100" @click='checkMail' v-if="stepMail !== 2">
                                    Запросить код
                                </button>
                                <button type="button" class="btn bg_lightgreen btn-lg text-white w-100" @click="checkCode('email')" v-if="stepMail == 2">
                                    Подтвердить
                                </button>
                            </div>
                            <div class="col-12 col-md-6">
                                <button type="button" class="btn btn-danger btn-lg w-100" data-bs-dismiss="modal">
                                    Отмена
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content bg_green">
                    <div class='modal-header border-0 d-flex align-items-center justify-content-between'>
                        <h5 class='modal-title'>Изменить номер</h5>
                        <div class="d-flex align-items-center justify-content-end">
                            <span :class="stepPhone > 0 ? 'operation_steps_active' : 'operation_steps'">1</span>
                            <img width="49" height="2" src="/static/img/buy/line.svg" />
                            <span :class="stepPhone > 1 ? 'operation_steps_active' : 'operation_steps'">2</span>
                        </div>
                    </div>
                    <div class='modal-body register_block'>
                        <div class="mb-2"><span v-if="stepPhone !== 2">Введите новый телефон</span></div>
                        <div class="mb-3" v-if="stepPhone !== 2">
                            <MazPhoneNumberInput id="ver_checkPhone" v-if="isCode == false && step < 2" v-model="newPhone" class="w-100"
                                @update="results = $event, checkALlFields()" show-code-on-list show-flag fetch-country
                                no-example border-radius=4 color="primary" valid-color="primary" :size="'sm'"
                                :preferred-countries="['RU', 'UZ', 'KZ']" :translations="{
                                    countrySelectorLabel: 'Код страны',
                                    countrySelectorError: 'Ошибка',
                                    phoneNumberLabel: 'Номер телефона',
                                    example: 'Пример: '
                                }" />
                        </div>
                        <p class="my-4 w-75" v-if="stepPhone !== 2">Позвоним на этот номер, для подтверждения вам понадобится ввести 4 последние цифры номера</p>
                        <div class="error-block-text" v-if="errorText.phone">
                            <p>{{ errorText.phone }}</p>
                        </div>
                            <div class="mb-3" v-if="stepPhone == 2">
                                <p>Введите 4 последние цифры</p>
                                <input id="ver_codeForPhone" type="number" class="form-control shadow-none" v-model='codeForPhone' placeholder='Код из номера'>
                            </div>
                            <span v-if="stepPhone == 2">Звонок поступит на номер {{phone}} <span class="text-green cursor-pointer" @click="stepPhone = 1" >Изменить</span></span>
                            <div class="row mt-5 gy-2">
                                <div class="col-12 col-md-6">
                                    <button type="button" class="btn bg_lightgreen btn-lg text-white w-100" @click='checkPhone' v-if="stepPhone !== 2">
                                        Запросить код
                                    </button>
                                    <button type="button" class="btn bg_lightgreen btn-lg text-white w-100" @click="checkCode('phone')" v-if="stepPhone == 2">
                                        Подтвердить
                                    </button>
                                </div>
                                <div class="col-12 col-md-6">
                                    <button type="button" class="btn btn-danger btn-lg w-100" data-bs-dismiss="modal">
                                        Отмена
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>

import { VueTelInput } from 'vue-tel-input';

export default {
    props: ['user'],
    components: {
        VueTelInput,
    },
    data() {
        return {
            step: 1,
            stepMail: 1,
            stepPhone: 1,
            selfi: '',
            pass1: '',
            pass2: '',
            pass3: '',
            reader: '',
            fio: '',
            mail: '',
            phone: '',
            codeForPhone: '',
            codePhone: '123',
            codeForMail: '',
            codeMail: '123',
            newMail: '',
            newPhone: '',
            maxSize: 5242880,
            ALlFields: false,
            isCode: false,
            isCodeMail: false,
            isCodePhone: false,
            errorText: {
                phone: '',
                mail: '',
            },
            new_call: false,
            countDown: 30,
            dropdownOptions: {
                disabled: false,
                showDialCodeInSelection: false,
                showDialCodeInList: true,
                showSearchBox: false,
                showFlags: true,
            },
            inputOptions: {
                placeholder: 'Номер телефона',
                showDialCode: true,
                styleClasses: 'mt-0 p-all-5px',
            },
            session_id: null,
            loading: false,
            results: false,
            imageUrl1: null,
            imageUrl2: null,
            imageUrl3: null
        }
    },
    watch: {
        'user.status': function (newValue, oldValue) {
            if (newValue === 4) {
                this.step = 1;
            }
        }
    },
    methods: {
        setErrors(response) {
            const errors = response?.data?.errors || {};
            let message;
            for (const field in errors) {
                message = errors[field][0];
            }
            let text = message || response?.data?.message || 'Что-то пошло не так';
            eventBus.$emit('errorBus', text);
        },
        countDownTimer() {
            if (this.new_call == false) {
                this.new_call = true;
                this.checkPhone();
            }
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
            if (this.countDown == 0) {
                this.countDown = 30;
                this.new_call = false;
            }
        },
        closeModal(modalId) {
            const modalEl = document.getElementById(modalId);
            if (modalEl) {
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
            }
            }
        },
        next() {
            if (this.step < 3) {
                if (this.$metrika !== undefined) {
                    this.$metrika.reachGoal('verification_2nd_step');
                }
                this.step = 3;
            } else {
                this.step++;
            }
        },
        prev() {
            if (this.phone != '' && this.isCode == false) {
                this.step = 2;
            } else {
                this.step = 1;
            }
        },
        addSelfi(event) {
            if ((event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'application/pdf')
                && event.target.files[0].size < this.maxSize) {
                this.selfi = event.target.files[0];
            } else {
                eventBus.$emit('errorBus', 'Неверный формат или размер файла превышает 5Мб');
                this.selfi = '';
            }
        },
        addPass1(event) {
            if ((event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'application/pdf')
                && event.target.files[0].size < this.maxSize) {
                this.pass1 = event.target.files[0];
                this.imageUrl1 = URL.createObjectURL(this.pass1);
            } else {
                eventBus.$emit('errorBus', 'Неверный формат или размер файла превышает 5Мб');
                this.pass1 = '';
            }
        },
        addPass2(event) {
            if ((event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'application/pdf')
                && event.target.files[0].size < this.maxSize) {
                this.pass2 = event.target.files[0];
                this.imageUrl2 = URL.createObjectURL(this.pass2);
            } else {
                eventBus.$emit('errorBus', 'Неверный формат или размер файла превышает 5Мб');
                this.pass2 = '';
            }
        },
        addPass3(event) {
            if ((event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'application/pdf')
                && event.target.files[0].size < this.maxSize) {
                this.pass3 = event.target.files[0];
                this.imageUrl3 = URL.createObjectURL(this.pass3);
            } else {
                eventBus.$emit('errorBus', 'Неверный формат или размер файла превышает 5Мб');
                this.pass3 = '';
            }
        },
        send() {
            let formData = new FormData();
            formData.append("full_name", this.fio);
            formData.append("main_passport_image", this.pass1);
            formData.append("registration_passport_image", this.pass2);
            formData.append("selfie_image", this.pass3);
            axios.post(this.$api_address + '/users/verification', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem('user_token')}`
                }
            }).then(response => {
                this.step = 4;
                this.$emit('verify');
                if (this.$metrika !== undefined) {
                    this.$metrika.reachGoal('verif_application');
                }
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                }
                else {
                    eventBus.$emit('logout');
                }
            });
        },

        //Проверка кода
        checkCode(type) {
            let data = {
                code: type == 'phone' ? this.codeForPhone : this.codeForMail,
                type: type == 'phone' ? "phone" : "email",
                value: type == 'phone' ? this.newPhone : this.newMail,
            }
            axios.post(this.$api_address + '/users/check_code', data, {
            }).then(response => {
                type == 'phone' ? this.changePhone() : this.changeMail();
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                }
                else {
                    eventBus.$emit('logout');
                }
            });
        },

        /*Регистрируем телефон*/
        checkPhone() {
            let data = { phone: this.newPhone }
            if (this.results.countryCode) {
                data.country_code = this.results.countryCode;
            }
            axios.post(this.$api_address + '/users/phone_verify', data, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                },
            }).then(response => {
                this.stepPhone = 2;
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                } else {
                    eventBus.$emit('logout');
                }
            });
        },

        checkMail() {
            let data = { email: this.newMail }
            axios.post(this.$api_address + '/users/email_verify', data, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                },
            }).then(response => {
                this.stepMail = 2;
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                } else {
                    eventBus.$emit('logout');
                }
            });
        },

        checkALlFields() {
            if (this.pass1 != '' && this.pass2 != '' && this.pass3 != '' && this.fio != '') {
                this.ALlFields = true;
            } else {
                this.ALlFields = false;
            }
        },
        close(event) {
            this.$emit('close');
        },
        // back() {
        //     this.isChangeMail = false;
        //     this.isChangePhone = false;
        // },
        changePhone() {
            let data = {
                phone: this.newPhone,
            }
            if (this.results.countryCode) {
                data.country_code = this.results.countryCode;
            }
            axios.patch(this.$api_address + '/users/change_phone', data, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                },
            }).then(response => {
                this.isCodePhone = true;
                this.errorText.phone = '';
                this.phone = this.newPhone;
                this.newPhone = '';
                this.codeForPhone = '';
                this.stepPhone = 1;
                this.closeModal('exampleModal2');
                eventBus.$emit('errorBus', 'Номер изменен', true);
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                } else {
                    this.closeModal('exampleModal2');
                    eventBus.$emit('logout');
                }
            });
        },

        /*Меняем мыло*/
        changeMail() {
            let data = {
                email: this.newMail,
            }
            axios.patch(this.$api_address + '/users/change_mail', data, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                },
            }).then(response => {
                this.isCodeMail = true;
                this.errorText.mail = '';
                this.mail = this.newMail;
                this.newMail = '';
                this.codeForMail = '';
                this.stepMail = 1;
                this.closeModal('exampleModal');
                eventBus.$emit('errorBus', 'Email изменен', true);
            }).catch((error) => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                } else {
                    this.closeModal('exampleModal');
                    eventBus.$emit('logout');
                }
            });

        }
    }
}
</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style>
.vti__dropdown-item {
    color: #000;
}
</style>
